import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(),
        getByLicense: state => licenseId => {
          return state.objs.filter(yb => yb.license === licenseId);
        },
        getByYbLicense: state => ybLicense => {
            return state.objs.find(yb => yb.ybLicense === ybLicense);
        }
    },
    mutations: {
        ...functions.createDefaultMutations()
    },
    actions: {
        ...functions.createDefaultActionsWithStore()
    },
}